module.exports = __webpack_public_path__ + "static/media/gtm3.bf23becb.png";